<template>
  <div>
    <navBar />
    <div class="conversion-container main-container">
      <div class="bg-container">
        <img src="@/assets/images/solution/marketing-bg.png">
        <p>解决方案</p>
      </div>
      <h1>零售行业会员精细化运营与营销解决方案</h1>
      <span class="line"></span>
      <div class="industry">
        <img src="@/assets/images/solution/marketing-logo.png">
        <div class="info">
          <h2>行业特点：</h2>
          <p>
          行业基本是B2C业务体系，有多重销售通路和业务渠道，需要对大量终端消费者进行运营与营销，提高用户新客转化与老客复购，同时培养客户对品牌的长期粘性与忠诚度。
          </p>
        </div>
      </div>
      <div class="step">
        <div class="info">
          <h2>解决问题：</h2>
          <p><span>•</span>设计更好的用户旅程体验，让客户从注册快速转为新客体验产品。</p>
          <p><span>•</span>实现客户数据洞察，设计更加有效的招募、营销、服务，保持与提高客户与品牌的互动性，提高客户复购。</p>
          <p><span>•</span>搭建私域平台，将高价值活跃客户沉淀在品牌可把握的区域，通过建立交易外的互动模式提高客户日常活跃度，发掘品牌KOL或KOC。</p>
          <h2 style="padding-top: 96px">方案创新：</h2>
          <p>
           以CRM为核心，打通会员UGC与导购服务场景，实现更多业务场景互动。结合多渠道用户数据关联，实现用户画像的多渠道应用，同时利用自动化智能营销系统打通用户旅程，实现关键节点的重要信息推送，提高新客转化，预防老客流失，整体提升CRM与业务KPI增长。
          </p>
        </div>
        <img  src="@/assets/images/solution/marketing-steps.png">
      </div>

      <div class="tags">
        <div class="box">
          <img src="@/assets/images/solution/vip.png">
          <span></span>
          <h3>会员体系与搭建</h3>
          <p>会员旅程设计</p>
          <p>会员定义与招募</p>
          <p>等级、权益与积分管理</p>
          <p>UGC社区搭建</p>
        </div>
        <div class="box">
          <img src="@/assets/images/solution/data-tag.png">
          <span></span>
          <h3>数据标签与客户洞察</h3>
          <p>客户多渠道数据整合</p>
          <p>会员标签体系建设</p>
          <p>客户全景视图</p> 
        </div>
        <div class="box">
          <img src="@/assets/images/solution/intelligent.png">
          <span></span>
          <h3>智能化精准营销</h3>
          <p>精准化目标客户管理</p>
          <p>精准目标营销</p>
          <p>智能化、自动化营销流程</p>
        </div>
        <div class="box">
          <img src="@/assets/images/solution/wechat.png">
          <span></span>
          <h3>企业微信B2B2C营销赋能</h3>
          <p>导购会员分配</p>
          <p>业务数据管理</p>
          <p>营销任务管理</p>
          <p>会员数据标签</p>
        </div>
      </div>
    </div>
    <footerBar />
  </div>
</template>
<script>
import navBar from "@/components/nav-bar";
import footerBar from "@/components/footer-bar";
export default {
  components: {
    navBar,
    footerBar
  },
}
</script>
<style lang="scss" scoped>
.conversion-container {
  padding-bottom: 10px;
  .bg-container {
    position: relative;
    overflow: hidden;
    max-width: 1920px;
    min-width: $min-screen-width;
    margin: 0 auto;
    p {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      // line-height: 68px;
      color: #FFFFFF;
      position: absolute;
      top: 208px;
      left: 645px;
    }
  }
  h1 {
    padding-top: 110px;
    padding-bottom: 25px;
    font-size: $font-size-32;
    font-family: Source Han Sans CN;
    font-weight: 400;
    // line-height: 30px;
    color: #333333;
    text-align: center;
    // letter-spacing: 40px;
  }
  .line {
    display: block;
    width: 60px;
    height: 2px;
    background: #1F71FF;
    margin: 0 auto;
    margin-bottom: 90px;
  }
  .industry {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    // justify-content: space-around;
    padding-bottom: 90px;
    .info {
      text-align: left;
      padding-left: 20px;
      h2 {
        font-size: $font-size-20;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #3B3B3B;
        padding-bottom: 40px;
      }
      p {
        font-size: $font-size-18;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 31px;
        color: #707070;
        width: 430px;
      }
    }
  }
  .step {
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    margin-bottom: 154px;
    .info {
      width: 520px;
      h2 {
        font-size: $font-size-20;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 44px;
        color: #3B3B3B;
        padding-bottom: 40px;
      }
      p {
        font-size: $font-size-18;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 31px;
        color: #707070;
        display: flex;
        span {
          font-size: 15px;
          margin-right: 10px;
        } 
      }
    }
  }

  .tags {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 65px;
    justify-content: space-between;
    .box {
      width: 300px;
      text-align: center;
      img {
        margin-bottom: 43px;
      }
      span {
        display: block;
        width: 40px;
        height: 2px;
        background: #1F71FF;
        margin: 0 auto;
        margin-bottom: 23px;
      }
      h3 {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 800;
        color: #464646;
        margin-bottom: 30px;
      }
      p {
        font-size: $font-size-14;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 30px;
        color: #707070;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/solution/marketing.vue